<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <h4 v-if="readOnly">
          {{ row_in.in_type === "FACTURE" ? "Facture " : "Avoir " }} N°
          {{ row_in.in_num }} | {{ row_in.wines.length }} vins |
          <span v-if="row_in.in_type == 'AVOIR'">-</span
          >{{ row_in.in_price_ht | formatPriceDivisePar100 }}
          <span v-if="row_in.in_typepaiement">
            | {{ row_in.in_typepaiement }}
          </span>
          <span v-if="row_in.in_payed"> | Payé</span>
          <span v-if="row_in.in_type === 'AVOIR'">
            | {{ row_in.user | formatContactNameSimple }}</span
          >
          <span v-if="row_in.in_type === 'AVOIR'">
            | {{ row_in.createdAt | formatDate }}</span
          >
          <button @click="emitEditInvoice" class="btn btn-primary btn-sm ms-2 ">
            Modifier
          </button>
        </h4>
      </div>
      <div class="d-flex" v-if="!createAvoir">
        <!--<div
          class="d-flex justify-content-end"
          v-if="
            row_in.in_type === 'AVOIR' &&
              $store.state.user.us_type === 'superadmin'
          "
        >
          <div @click.stop="editAvoir()" class="pointer">
            <icon name="edit"></icon>
          </div>
          <div @click.stop="deleteConfirmAvoir()" class="ms-3 pointer">
            <icon color="#950605" name="trash-alt"></icon>
          </div>
        </div> -->
        <!--  <div @click="printEtiquette" class="pointer">
          <icon name="box-open"></icon>
        </div> -->
        <div
          @click="sendFacture"
          class=" pointer ms-2"
          v-tooltip
          data-bs-placement="left"
          title="Recevoir la facture par email"
        >
          <icon color="#3fb1dc" name="envelope"></icon>
        </div>
        <div
          @click="print"
          class=" pointer ms-2"
          v-tooltip
          data-bs-placement="left"
          title="Télécharger la facture au format PDF"
        >
          <icon name="print"></icon>
        </div>
      </div>
    </div>
    <div>
      <!-- grands écrans -->
      <m-list-simple
        tableClass="table-hover table-striped d-none d-md-table"
        ref="winelist"
        :dynamic="true"
        :items="row_in.wines"
        item-value="wi_id"
      >
        <template v-slot:ths="{}">
          <th v-if="createAvoir"></th>
          <th><span>Ajouté le</span></th>
          <th><span>Nom</span></th>
          <th><span>Dénomination</span></th>
          <th><span>Couleur</span></th>
          <th><span>Millésime</span></th>
          <th v-if="!createAvoir && row_in.in_type === 'FACTURE'">
            <span>Avoir</span>
          </th>
        </template>
        <template v-slot:tds="{ item }">
          <td v-if="createAvoir">
            <input
              type="checkbox"
              id="selectWine"
              :name="$Utils.randomstring('selectWine')"
              @input="selectWine(item)"
              :checked="getValue(item)"
              :disabled="item.in_id_avoir && !avoirId"
            />
          </td>
          <td>{{ item.createdAt | formatDate }}</td>
          <td>{{ item | formatWineName }}</td>
          <td>
            {{
              item.denomination
                ? item.denomination.de_name
                : item.wi_denomination
            }}
          </td>
          <td>{{ item.wi_couleur | formatWineColor }}</td>
          <td>{{ item.wi_millesime | formatWineMillesime }}</td>
          <td v-if="!createAvoir && row_in.in_type === 'FACTURE'">
            {{ item.in_id_avoir ? "Oui" : "" }}
          </td>
        </template>
      </m-list-simple>
      <!-- petits écrans -->
      <m-list-simple
        tableClass="table-hover table-striped d-md-none"
        ref="winelist"
        :dynamic="true"
        :items="row_in.wines"
        item-value="wi_id"
      >
        <template v-slot:ths="{}"></template>
        <template v-slot:tds="{ item }">
          <td>
            <div>{{ item | formatWineName }}</div>
            <div>
              {{
                item.denomination
                  ? item.denomination.de_name
                  : item.wi_denomination
              }}
              - {{ item.wi_couleur | formatWineColor }} -
              {{ item.wi_millesime | formatWineMillesime }}
            </div>
            <div>Ajouté le : {{ item.createdAt | formatDate }}</div>
            <div v-if="row_in.in_type === 'FACTURE' && item.in_id_avoir">
              <span class="text-danger">Dans un avoir</span>
            </div>
          </td>
        </template>
      </m-list-simple>
      <!--  -->
    </div>
  </div>
</template>

<script>
export default {
  name: "FrameInvoice",
  components: {},
  props: {
    readOnly: Boolean,
    createAvoir: Boolean,
    avoirId: Number,
    row_in: {
      type: Object,
      default: function() {
        return { wines: [] };
      }
    },
    // row_pa: {
    //   type: Object,
    //   default: function() {
    //     return {};
    //   }
    // },
    keyload: Number
  },
  data() {
    return {
      price: 0,
      winesSelectedToAvoir: [],
      avoirWinEdit: false
    };
  },
  watch: {
    keyload: function(v) {},
    row_in: function(v) {
      // console.log("row_in", v);
      // this.price = this.row_in.in_price_ht / 100;
    }
    // row_pa: function(v) {
    //   console.log("row_pa", v);
    //   // this.price = this.row_in.in_price_ht / 100;
    // }
  },
  computed: {},
  async mounted() {
    // console.log("row_pa", this.row_pa);
    // console.log("row_in", this.row_in);
    // this.price = this.row_in.in_price_ht / 100;
  },
  methods: {
    getValue(item) {
      let val = false;
      if (this.avoirId && this.avoirId === item.in_id_avoir) val = true;
      return val;
    },
    emitCreateAvoir() {
      this.$emit("emitCreateAvoir", this.row_in.in_id);
    },
    canEditWine(item) {
      if (!this.createAvoir) {
        this.editWine(item);
      }
    },
    editWine(item) {
      this.$emit("emitEditWine", item);
    },
    emitEditInvoice() {
      this.$emit("emitEditInvoice", this.row_in.in_id);
    },
    async saveFacture() {
      let data = {
        in_typepaiement: this.row_in.in_typepaiement,
        in_price_ht: this.row_in.in_price_ht,
        in_payed: this.row_in.in_payed,
        in_auto: this.row_in.in_auto
      };
      let response = await this.$axios.put(
        this.$config.server_url +
          "/backoffice/1.0/invoices/" +
          this.row_in.in_id,
        data
      );
      if (response.data.data.success) {
        this.$store.dispatch("showToast", {
          title: "Edition d'un facture",
          text: "La facture a bien été modifiée",
          color: "green"
        });
        this.$emit("emitInvoicesAction");
      }
    },

    selectWine(item) {
      let index = this.winesSelectedToAvoir.findIndex(wine => {
        return wine.wi_id === item.wi_id;
      });
      if (index >= 0) {
        this.winesSelectedToAvoir.splice(index, 1);
      } else {
        this.winesSelectedToAvoir.push(item);
      }
      this.$emit("emitwinesAvoir", this.winesSelectedToAvoir);
    },
    async print() {
      let data = {
        in_id: this.row_in.in_id,
        eventLog: "printInvoice"
      };
      data.comment = this.row_in.in_type === "AVOIR" ? "avoir" : "facture";
      await this.$axios.post(
        this.$config.server_url + "/candidats/1.0/addlog/",
        data
      );
      window.open(
        `${this.$config.server_url}/candidats/1.0/invoices/${this.row_in.in_id}/print?token=${this.$store.state.accesstoken}&origin=${this.$config.candidats_url}`,
        "_blank"
      );
    },
    /*     printEtiquette() {
      window.open(
        `${this.$config.server_url}/candidats/1.0/invoices/${this.row_in.in_id}/etiquette?token=${this.$store.state.accesstoken}&origin=${this.$config.candidats_url}`,
        "_blank"
      );
    }, */
    async sendFacture() {
      let response = await this.$axios.get(
        this.$config.server_url +
          "/candidats/1.0/invoices/" +
          this.row_in.in_id +
          "/send"
      );
      if (response.data.data.success) {
        this.$store.dispatch("showToast", {
          title: "Confirmation ",
          text: "La facture a bien été envoyée",
          color: "green"
        });
      } else {
        this.$store.dispatch("showToast", {
          title: "Erreur ",
          text: response.data.data.error,
          color: "red"
        });
      }
    }

    //// si invoices et un avoir
    /*    editAvoir() {
      this.$emit("emitAvoirEdit", this.row_in);
    },
    deleteConfirmAvoir() {
      this.confirmdelete = true;
    },
    async deleteA() {
      this.confirmdelete = false;
      let response = await this.$axios.delete(
        this.$config.server_url + "/backoffice/1.0/invoices/" + this.row_in.in_id
      );
      if (response.data.data.success) {
        this.$store.dispatch("showToast", {
          title: "Candidat",
          text: "L'avoir " + response.data.data.in_num + " a bien été supprimé",
          color: "green"
        });
      }
      this.$emit("emitAvoirAction");
    } */
  }
};
</script>

<style lang="scss" scoped></style>
